<template>
  <v-container fluid>
    <ProjectKPI
      :dashboard="dashboard"
      :projectId="project.id"
    />
    <ProjectName
      class="mt-6"
      :project="dashboard"
    />
    <Timeline
      class="mt-6"
      :events="dashboard.timeline"
    />
  </v-container>
</template>

<script>
import ProjectName from "@/components/ri3/ProjectName.vue"
import { Timeline } from "@/components"
import ProjectService from "@/services/ProjectService"
import ProjectKPI from "@/views/project/ProjectKPI.vue"

export default {
  components: { ProjectKPI, ProjectName, Timeline },
  name: "Dashboard",
  data() {
    return {
      dashboard: {
        completion_percent: 0,
        created_at: "",
        description: "",
        inspector: null,
        non_conformities_kpi: 0,
        role: "",
        tasks_kpi: 0,
        actions_kpi: 0,
        team: [],
        timeline: []
      },
      loading: true
    }
  },
  created() {
    this.init()
  },
  computed: {
    hasTimelineEvents() {
      return this.dashboard.timeline.length > 0
    },
    project() {
      return this.$store.state.app.project
    }
  },
  methods: {
    init() {
      this.loading = true
      ProjectService.get_dashboard(this, this.project.id)
        .then(r => {
          this.dashboard = r
          this.dashboard.role = this.project.role
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    "$store.state.app.project": function () {
      this.init()
    }
  }
}
</script>
